import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-design-grid',
  templateUrl: './design-grid.component.html',
  styleUrls: ['./design-grid.component.scss']
})
export class DesignGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
